import { Compute } from 'cerebral'
import { state } from 'cerebral/tags'
import controller from 'controller'
import nodePathFromArray from 'utils/nodePathToArray'
import alphabeticalSortASC from 'utils/alphabeticalSortASC'

const valueSortASC = (a, b) => b - a

const getSortFn = sort => {
  switch (sort) {
    case 'LATEST':
      return (a, b) => valueSortASC(a.addedAt, b.addedAt)
    case 'LATEST_REVERSE':
      return (a, b) => valueSortASC(a.addedAt, b.addedAt) * -1
    case 'A_Z':
      return (a, b) => alphabeticalSortASC(a.name, b.name)
    case 'Z_A':
      return (a, b) => alphabeticalSortASC(a.name, b.name) * -1
    default:
      return getSortFn('LATEST')
  }
}

const hasMatch = (id, [key, ...keys]) => {
  if (!key) return false
  if (id === key) return true
  return hasMatch(id, keys)
}

const filterUploads = (uploads, key) =>
  Object.entries(uploads)
    .filter(([_, file]) => file.node === key && !file.moved)
    .map(([_, file]) => ({ ...file, path: `media.uploading.${file.id}` }))

const getNodeObj = (nodeObj, nodes, [id, ...ids]) => {
  if (!id) return nodeObj
  if (hasMatch(id, Object.keys(nodes)))
    return getNodeObj(
      {
        ...nodeObj,
        path: `${nodeObj.path}.nodes.${id}`,
        sortValue: nodeObj.sortValue + nodes[id].name
      },
      nodes[id].nodes,
      ids
    )

  return getNodeObj(nodeObj, nodes, [...ids, id])
}

const groupFileListByNode = get => files => {
  const uploads = controller.getState('media.uploading')
  const nodes = controller.getState('node.nodes')

  const getGroupObjFn = node =>
    getNodeObj({ path: 'node', sortValue: '', type: 'node' }, nodes, [
      node.id,
      ...node.paths
    ])

  const { id = null, path } = controller.getState('node.selectedNode')
  if (id && !files.length) {
    const paths = nodePathFromArray(path)
    paths.splice(paths.indexOf(id), 1) // removes current node from list
    return {
      [id]: {
        ...getGroupObjFn({ id, paths }),
        files: [...filterUploads(uploads, id)]
      }
    }
  }

  return files.reduce((acc, file) => {
    const id = file.node.id
    return {
      ...acc,
      [id]: !acc[id]
        ? {
            ...getGroupObjFn(file.node),
            files: [...filterUploads(uploads, id), file]
          } // when there is no group, make one
        : { ...acc[id], files: [...acc[id].files, file] }
    }
  }, {})
}

// If we were to introduce more groupTypes, this is where we do it
const determineGrouping = (controller, group) => {
  switch (group) {
    default:
      return groupFileListByNode(controller)
  }
}

export default Compute(
  state`media.sortType`,
  state`node.selectedNode`,
  state`media.files.*`,
  state`media.uploading`,
  state`media.filter.repaint`,
  (sort, __selectedNode, __refreshing, __uploads, __repaint) => {
    const grouping = 'node'
    const files = controller.getState('media.files')
    const sortedFileList = Object.entries(files)
      .map(([_, file]) => ({ ...file, path: `media.files.${file.id}` }))
      .filter(file => !file.hidden)
      .sort(getSortFn(sort))

    const groupFileList = determineGrouping(controller, grouping)

    return Object.entries(groupFileList(sortedFileList))
      .map(([_, group]) => group)
      .sort((a, b) => alphabeticalSortASC(a.sortValue, b.sortValue))
  }
)



// WEBPACK FOOTER //
// ./src/modules/Media/computed/mediaViewItems.js